//replaces keyword-analysis-total-visits-dashboard.html

import { KeywordAnalysisTotalVisits } from "app/components/React/KeywordAnalysisTotalVisits/KeywordAnalysisTotalVisits";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import type { FC } from "react";
import styled from "styled-components";

const KeywordAnalysisTotalVisitsWrapper = styled.div`
    padding-top: 50px;
`;
KeywordAnalysisTotalVisitsWrapper.displayName = "KeywordAnalysisTotalVisitsWrapper";

export const keywordAnalysisTotalVisitsDashboardV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    return (
        <KeywordAnalysisTotalVisitsWrapper>
            <KeywordAnalysisTotalVisits
                trafficTrend={widget.data}
                dashboardView={true}
                maxMonths={widget.maxMonths}
            />
        </KeywordAnalysisTotalVisitsWrapper>
    );
};
